import * as s from "../ModalTemplateStyled";
import ModalTemplate from "../ModalTemplate";
import { forwardRef } from "react";
import { GrClose } from "react-icons/gr";

type Props = {
  children: React.ReactNode;
  onModal?: () => void;
  button: React.ReactNode;
  disableClose?: boolean;
  className?: string;
};
const SmallPopupDefaultTemplate = forwardRef<HTMLDivElement, Props>(
  (
    { children, onModal, button, disableClose, className }: Props,
    ref
  ): JSX.Element => {
    return (
      <ModalTemplate ref={ref} className={className}>
        <s.SmallContainer className="small-popup-container">
          <s.SmallWrapper className="small-popup-wrapper">
            {disableClose === undefined && (
              <s.CloseButton
                onClick={(e) => {
                  e.stopPropagation();
                  onModal && onModal();
                }}
                className="small-popup-close-button"
                data-testid="templates-modal-small-close-button-stop-propagation"
              >
                <GrClose size={16} />
              </s.CloseButton>
            )}

            <s.SmallInner className="small-popup-inner">
              {children}
            </s.SmallInner>
            <s.SmallButtonWrapper className="small-popup-button-wrapper">
              {button}
            </s.SmallButtonWrapper>
          </s.SmallWrapper>
        </s.SmallContainer>
      </ModalTemplate>
    );
  }
);

export default SmallPopupDefaultTemplate;
